import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../../components/neu/Neu";
import { platformGreetingVoices, savePlatformGreetingVoices, setPlatformGreetingEnabled } from "../../../api/greetingVoices";
import { VoicePicker } from "./VoicePicker";
import { VoiceSaveConfirm } from "./VoiceSaveConfirm";
import { VoiceUsageCard } from "./VoiceUsageCard";
import { VoiceEnableToggle } from "./VoiceEnableToggle";

// أصوات التحية على مستوى المنصة كلها — لمالك المنصة فقط.
export const PlatformVoicePanel = () => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [form, setForm] = useState({ male: "", female: "", speed: 1.12, tone: "upbeat" });
  const [target, setTarget] = useState("male");
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [toggling, setToggling] = useState(false);

  const load = async () => {
    const res = await platformGreetingVoices();
    setData(res);
    setForm({
      male: res.config.greeting_voice_male,
      female: res.config.greeting_voice_female,
      speed: res.config.greeting_speed,
      tone: res.config.greeting_tone,
    });
  };

  useEffect(() => {
    load().catch(() => toast.error(t("errors.generic")));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await savePlatformGreetingVoices({ voice_male: form.male, voice_female: form.female, speed: Number(form.speed), tone: form.tone });
      setConfirming(false);
      await load();
      toast.success(t("greeting.saved"));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  const toggleEnabled = async (value) => {
    setToggling(true);
    try {
      await setPlatformGreetingEnabled(value);
      await load();
      toast.success(value ? t("greeting.enabledOn") : t("greeting.enabledOff"));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setToggling(false);
    }
  };

  if (!data) return null;

  return (
    <div className="grid gap-4" data-testid="platform-voice-panel">
      <VoiceEnableToggle enabled={data.config.greeting_enabled} busy={toggling} onChange={toggleEnabled} />
      <VoiceUsageCard usage={data.usage} balance={data.balance} provider={data.provider} />
      <NeuCard data-testid="greeting-voice-card">
        <p className="label-xs">{t("greeting.title")}</p>
        <p className="mt-2 text-xs text-muted-foreground">{t("greeting.hint")}</p>
        <VoicePicker
          voices={data.voices}
          form={form}
          setForm={setForm}
          target={target}
          setTarget={setTarget}
          lang={i18n.language === "en" ? "en" : "ar"}
          sampleName={t("greeting.sampleName")}
        />
        {confirming ? (
          <VoiceSaveConfirm usage={data.usage} busy={busy} onCancel={() => setConfirming(false)} onConfirm={save} />
        ) : (
          <NeuButton variant="primary" className="mt-4" data-testid="greeting-voice-save" onClick={() => setConfirming(true)}>
            {t("greeting.save")}
          </NeuButton>
        )}
      </NeuCard>
    </div>
  );
};
